<h1 mat-dialog-title>Zeitraum auswählen</h1>
<mat-dialog-content>
    <mat-form-field>
        <mat-label>Zeitraum von:</mat-label>
        <input [formControl]="vonCtrl" [matDatepicker]="picker1" matInput placeholder="Von" />
        <mat-datepicker-toggle [for]="picker1" matSuffix></mat-datepicker-toggle>
        <mat-datepicker #picker1></mat-datepicker>
    </mat-form-field>
    <mat-form-field style="margin-left: 24px">
        <mat-label>Zeitraum bis:</mat-label>
        <input [formControl]="bisCtrl" [matDatepicker]="picker2" matInput placeholder="Bis" />
        <mat-datepicker-toggle [for]="picker2" matSuffix></mat-datepicker-toggle>
        <mat-datepicker #picker2></mat-datepicker>
    </mat-form-field>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button (click)="cancel()" mat-button>Abbrechen</button>
    <button (click)="save()" [disabled]="vonCtrl.invalid || bisCtrl.invalid" color="accent" mat-flat-button>Ok</button>
</mat-dialog-actions>
